<template>
  <div class="vue-poll">
      <h3 id="title" class="qst" v-html="question"></h3>
      <div class="ans-cnt">
          <div v-for="(a,index) in calculateAnswers()" :key="index" :class="{ ans: true, [a.custom_class]: (a.custom_class) }">

              <template v-if="!finalResults">

                  <div v-if="!visibleResults" :class="{ 'ans-no-vote noselect': true, active: a.selected }" @click.prevent="handleVote(a)" >
                      <span class="txt" v-html="a.text"></span>
                  </div>
                  <div v-else :class="{ 'ans-voted': true, selected: a.selected }" >
                      <span v-if="a.percent" class="percent" v-text="a.percent"></span>
                      <span class="txt" v-html="a.text"></span>
                  </div>

                  <span :class="{ bg: true, selected: a.selected }" :style="{ width: visibleResults ? a.percent : '0%' }"></span>
              </template>
              <template v-else>
                  <div :class="{ 'ans-voted': true, selected: a.selected }">
                      <span v-if="a.percent" class="percent d-inline" v-text="a.percent"></span>
                      <span class="txt d-inline" v-html="a.text"></span>
                  </div>
                  <span :class="{ bg: true, selected: a.selected }" :style="{ width: a.percent }"></span>
              </template>

          </div>
      </div>
      <template v-if="!finalResults && !visibleResults && (multiple || submitButtonMode) && getTotalSelections() > 0">
            <span href="#" @click.prevent="handleSubmitButton" class="submit" v-text="submitButtonText"/>
      </template>
      <div class="prog-stats" v-if="showTotalVotes" v-text="getTotalVotesFormatted() + ' votes ' + getFormattedPollCloseDate() " :key="refresh"></div>
  </div>
</template>
<script>
export default {
  name: 'Poll',
  props: {
    question: {
      type: String,
      required: true
    },
    answers: {
      type: Array,
      required: true
    },
    isLocked: {
      type: Boolean,
      default: true
    },
    isRegisteredUser: {
      type: Boolean,
      default: false
    },
    showResults: {
      type: Boolean,
      default: false
    },
    showTotalVotes: {
      type: Boolean,
      default: true
    },
    votingEnds: {
      type: String,
      default: ''
    },
    finalResults: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    submitButtonMode: {
      type: Boolean,
      default: false
    },
    submitButtonText: {
      type: String,
      default: 'Submit'
    },
    customId: {
      type: Number,
      default: 0
    },
    isOpenForAnonymous: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      visibleResults: JSON.parse(this.showResults),
      refresh: 0
    }
  },
  computed: {
    canUserVote () {
      if (this.isOpenForAnonymous && !this.$store.state.isBeta) {
        return true
      } else {
        return this.$store.state.isRegisteredUser
      }
    },
    mostVotes () {
      let max = 0
      this.answers.filter(a => {
        if (!isNaN(a.votes) && a.votes > 0 && a.votes >= max) {
          max = a.votes
        }
      })
      return max
    }
  },
  methods: {
    calculateAnswers () {
      if (this.getTotalVotes() === 0) {
        return this.answers.map(a => {
          a.percent = '0%'
          return a
        })
      }
      // Calculate percent
      return this.answers.filter(a => {
        if (!isNaN(a.votes) && a.votes > 0) {
          a.percent = (Math.round((parseInt(a.votes) / this.getTotalVotes()) * 100)) + '%'
        } else {
          a.percent = '0%'
        }
        return a
      })
    },
    getTotalVotes () {
      let totalVotes = 0
      this.answers.filter(a => {
        if (!isNaN(a.votes) && a.votes > 0) {
          totalVotes += parseInt(a.votes)
        }
      })
      return totalVotes
    },
    getTotalSelections () {
      return this.calculateAnswers().filter(a => a.selected).length
    },
    getTotalVotesFormatted () {
      return this.getTotalVotes().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getFormattedPollCloseDate () {
      const closeDate = new Date(this.votingEnds)
      const now = new Date()
      const diffTime = closeDate - now
      const diffDays = diffTime / (1000 * 60 * 60 * 24)
      let returnVal = ''
      if (diffDays > 0 && diffDays < 1) {
        returnVal = '| less than a day left to vote'
      } else if (diffDays <= 0) {
        returnVal = '| poll is closed'
      } else {
        if (diffDays >= 1 && diffDays < 2) {
          returnVal = `| ${Math.floor(diffDays)} day left`
        } else if (diffDays >= 2) {
          returnVal = `| ${Math.floor(diffDays)} days left`
        }
      }
      return returnVal
    },
    handleSubmitButton () {
      let arSelected = []
      let obj = { totalVotes: this.getTotalVotes() }
      if (this.multiple) {
        this.calculateAnswers().filter(a => {
          if (a.selected) {
            a.votes++
            arSelected.push({ value: a.value, votes: a.votes })
          }
        })
        obj.arSelected = arSelected
      } else {
        const selectedSingleElement = this.calculateAnswers().find(e => e.selected === true)
        if (selectedSingleElement) {
          selectedSingleElement.votes++
          obj.value = selectedSingleElement.value
        }
      }

      this.visibleResults = true
      this.refresh++
      if (this.customId) {
        obj.customId = this.customId
      }
      this.$emit('addvote', obj)
    },
    handleVote (a) {
      if (!this.canUserVote) {
        this.$store.commit('startSignIn', 'CONTENT_BLOCKED')
        return
      }
      if (this.multiple) {
        if (a.selected === undefined) {
          console.info("Please add 'selected: false' on the answer object")
        }
        a.selected = !a.selected
        this.refresh++
        return
      }

      this.refresh++
      this.answers.forEach(item => {
        if (item !== a) {
          item.selected = false
        }
      })
      a.selected = !a.selected

      if (!this.submitButtonMode) {
        a.votes++
        let obj = { value: a.value, votes: a.votes, totalVotes: this.getTotalVotes() }
        if (this.customId) {
          obj.customId = this.customId
        }
        this.visibleResults = true
        this.$emit('addvote', obj)
      }
    }
  }
}
</script>
